var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseModal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#8AA4B5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1539 16.8004C31.6243 17.2707 31.6243 18.0343 31.1539 18.5046L25.7042 23.9543L31.1546 29.4047C31.6247 29.875 31.624 30.638 31.1539 31.1082C30.6837 31.5785 29.9208 31.579 29.4504 31.1089L24 25.6585L18.5496 31.1089C18.0792 31.579 17.3163 31.5785 16.8461 31.1082C16.376 30.638 16.3753 29.875 16.8454 29.4047L22.2958 23.9543L16.8461 18.5046C16.3757 18.0343 16.3757 17.2707 16.8461 16.8004C17.3164 16.3302 18.08 16.3301 18.5503 16.8004L24 22.2501L29.4497 16.8004C29.92 16.3301 30.6836 16.3302 31.1539 16.8004Z",
    fill: "#FEFEFE",
    stroke: "#FEFEFE",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModal);
export default __webpack_public_path__ + "static/media/Close-modal.30c723f2aa8c5b4595897396f05ba841.svg";
export { ForwardRef as ReactComponent };